export enum CoordinationUserErrorCodeType {
    UnauthorizedCoordinationClaim = 'UnauthorizedCoordinationClaim',
    CurrentUserNotACoordinationUser = 'CurrentUserNotACoordinationUser',
    CoordinationUsersNotFoundInCoordination = 'CoordinationUsersNotFoundInCoordination',
    CoordinationUserNotFoundInCoordination = 'CoordinationUserNotFoundInCoordination',
    OrganizationUsersNotFoundInOrganization = 'OrganizationUsersNotFoundInOrganization',
    CoordinationUserInvalidEmail = 'CoordinationUserInvalidEmail',
    CoordinationUserAlreadyExists = 'CoordinationUserAlreadyExists',
    CoordinationUserNotPartOfOrganization = 'CoordinationUserNotPartOfOrganization',
    NotAllowedToEditALinkedDataMinerUserName = 'NotAllowedToEditALinkedDataMinerUserName',
    UnauthorizedToSetCoordinationUserToThisCoordinationGroupId = 'UnauthorizedToSetCoordinationUserToThisCoordinationGroupId',
    UnauthorizedToUnsetCoordinationUserFromThisCoordinationGroupId = 'UnauthorizedToUnsetCoordinationUserFromThisCoordinationGroupId',
    NotAllowedToDemoteTheLastCoordinationOwner = 'NotAllowedToDemoteTheLastCoordinationOwner',
    ConcurrentUpdate = 'ConcurrentUpdate',
    UnauthorizedToDeleteCoordinationUserWithThisOrganizationGroupId = 'UnauthorizedToDeleteCoordinationUserWithThisOrganizationGroupId',
    NotAllowedToDeleteLastCoordinationOwner = 'NotAllowedToDeleteLastCoordinationOwner',
}
